<ion-header>
  <ion-toolbar>
    <ion-title>Logs de Conexión</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <!-- Estadísticas -->
  <ion-toolbar>
    <ion-segment [(ngModel)]="selectedFilter" (ionChange)="applyFilter()">
      <ion-segment-button value="all">
        <ion-label>
          Todos
          <ion-badge color="medium">{{ stats.total }}</ion-badge>
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="connection">
        <ion-label>
          Conexiones
          <ion-badge color="success">{{ stats.connections }}</ion-badge>
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="disconnection">
        <ion-label>
          Desconexiones
          <ion-badge color="warning">{{ stats.disconnections }}</ion-badge>
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="reconnection">
        <ion-label>
          Reconexiones
          <ion-badge color="tertiary">{{ stats.reconnections }}</ion-badge>
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="error">
        <ion-label>
          Errores
          <ion-badge color="danger">{{ stats.errors }}</ion-badge>
        </ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="logs-container">
    <!-- Acciones -->
    <div class="actions-bar">
      <ion-button fill="outline" size="small" (click)="loadLogs()">
        <ion-icon slot="start" name="reload"></ion-icon>
        Recargar
      </ion-button>
      <ion-button fill="outline" size="small" (click)="exportLogs()" [disabled]="logs.length === 0">
        <ion-icon slot="start" name="download"></ion-icon>
        Exportar
      </ion-button>
      <ion-button fill="outline" size="small" color="danger" (click)="clearLogs()" [disabled]="logs.length === 0">
        <ion-icon slot="start" name="trash"></ion-icon>
        Limpiar
      </ion-button>
    </div>

    <!-- Lista de logs -->
    <ion-list *ngIf="filteredLogs.length > 0; else noLogs">
      <ion-item *ngFor="let log of filteredLogs" class="log-item">
        <ion-icon slot="start" [name]="getLogIcon(log.type)" [color]="getLogColor(log.type)">
        </ion-icon>

        <ion-label>
          <div class="one_line">
            <h3>{{ log.message }}</h3>
            <p class="timestamp">{{ formatTimestamp(log.timestamp) }}</p>
          </div>
          <p *ngIf="log.details" class="details">
            <ion-text color="medium">
              <small>{{ formatDetails(log.details) }}</small>
            </ion-text>
          </p>
        </ion-label>
      </ion-item>
    </ion-list>

    <ng-template #noLogs>
      <div class="no-logs">
        <ion-icon name="information-circle-outline" color="medium"></ion-icon>
        <p>No hay logs{{ selectedFilter !== 'all' ? ' de este tipo' : '' }}</p>
      </div>
    </ng-template>
  </div>
</ion-content>